export const GET_LANGUAGES = 'app/Settings/GET_LANGUAGES';
export const UPDATE_SETTINGS_PROPERTY = 'app/Settings/UPDATE_SETTINGS_PROPERTY';
export const CHANGE_PASSWORD = 'app/Settings/CHANGE_PASSWORD';
export const GET_ACCESS_REQUESTS = 'app/Settings/GET_ACCESS_REQUESTS';
